// extracted by mini-css-extract-plugin
module.exports = {"btnBlue":"admin_btnBlue_ByP_t","btnBlueOutline":"admin_btnBlueOutline_2sO3s","invalidCoding":"admin_invalidCoding_2TvRZ","tabItem":"admin_tabItem_2k_M4"};